import * as Yup from 'yup'

export const commisisonItemFormSchema = Yup.object().shape({
    name: Yup.string().required('Commission Item Name is Required'),
    payOutType: Yup.string().oneOf(['Fixed Amount', 'Percentage on Net Selling Price']).required('Pay out Type is required'),
    targetBy: Yup.string().oneOf(['Net Selling Price', 'No. of Unit']).required('Target By is required'),
    interval: Yup.string().min(1).required('Interval In Month is required'),
})